import request from '@/utils/request'
/**
 * @apiName 车辆资损情况-维修金额
 */
export function vehicleMaintenancePayInfoApi(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/data/board/vehicleMaintenancePayInfo',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 车辆资损情况-维修变化趋势
 */
export function vehicleMaintenanceLineApi(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/data/board/vehicleMaintenanceLine',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 车辆资损情况-维修分布
 */
export function vehicleMaintenanceDistributionApi(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/data/board/vehicleMaintenanceDistribution',
    method: 'POST',
    data,
  })
}
